/**
 * Featured Blog Slider Module
 * Handles the initialization and functionality of the featured blog slider/carousel.
 * @module FeaturedBlog
 */
(function () {
  /**
   * Initializes and configures the blog slider functionality.
   * Sets up Swiper instance with responsive breakpoints and slide change animations.
   * @function blogSlider
   */
  const blogSlider = () => {
    $('.section-featured-blog').each(function () {
      const slide = $(this).find('.swiper-slide');
      const carousel = $(this).find('.feat-blog-swiper');
      const buttonNext = $(this).find('.swiper-button-next');

      if ($(this).hasClass('slider_started')) {
        return '';
      }

      $(this).addClass('slider_started');
      const id = $(this).attr('id');

      let featBlogParams = {
        slidesPerView: 1.1,
        waitForTransition: false,
        updateOnWindowResize: true,
        preLoadImage: true,
        autoHeight: false,
        allowTouchMove: true,
        spaceBetween: 4,
        breakpoints: {
          576: {
            slidesPerView: 2.1,
          },

          1360: {
            slidesPerView: 3.1,
          },

          2340: {
            slidesPerView: 4.1,
          },

          2640: {
            slidesPerView: 5.1,
          },
        },
        on: {
          slideChange: function () {
            if (this.activeIndex === 0) {
              Array.from(slide).forEach((element) => {
                element.classList.remove('slide_change-postion');
              });
              Array.from(carousel).forEach((element) => {
                element.classList.add('carousel_change-postion_next');
                element.classList.remove('carousel_change-postion_prev');
                element.classList.remove('carousel_change-postion_next-2');
              });
              this.update();
            } else {
              if (this.activeIndex > this.previousIndex) {
                Array.from(carousel).forEach((element) => {
                  element.classList.remove('carousel_change-postion_next');
                  element.classList.remove('carousel_change-postion_next-2');
                  element.classList.add('carousel_change-postion_prev');
                });
                Array.from(slide).forEach((element) => {
                  if (buttonNext.hasClass('swiper-button-disabled')) {
                    element.classList.remove('slide_change-postion');
                  } else {
                    element.classList.add('slide_change-postion');
                  }
                });
              } else {
                Array.from(carousel).forEach((element) => {
                  element.classList.add('carousel_change-postion_next-2');
                  element.classList.remove('carousel_change-postion_prev');
                });
                Array.from(slide).forEach((element) => {
                  element.classList.remove('slide_change-postion');
                });
              }
              this.update();
            }
          },
        },
      };

      const swiper1 = new Swiper(`#${id} .feat-blog-swiper`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next_blog`,
          prevEl: `#${id} .swiper-button-prev_blog`,
        },
        ...featBlogParams,
      });
    });
  };

  /**
   * Initializes the blog slider when a Shopify section is loaded.
   * Uses a small delay to ensure proper DOM rendering.
   */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(() => {
      blogSlider();
    }, 100);
  });

  /**
   * Initializes the blog slider when the window is fully loaded.
   * Uses a small delay to ensure proper DOM rendering.
   */
  window.addEventListener('onload', function () {
    setTimeout(() => {
      blogSlider();
    }, 100);
  });

  // Initial slider setup
  setTimeout(() => {
    blogSlider();
  }, 100);
})();
